"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.savePdf = void 0;

var FileSaver = require('file-saver');

var savePdf = function savePdf(result, name) {
  FileSaver.saveAs(result, name);
};

exports.savePdf = savePdf;